module.exports = __webpack_public_path__ + "img/4-map.4528b34e.jpg";